<div 
  class="notification-container" 
  [class.danger]="VisualType() === 'danger'"
  [class.animate-out]="DisplayTimeEnded()" 
  (animationend)="OnAnimationEnd()">
  <button type="button" class="close-button" (click)="OnCloseButtonClicked()">
    <i class="bi bi-x-lg"></i>
  </button>
  <div class="message">{{ Message() }}</div>
  @if (DisplayTime() > 0){
    <div class="time-left">{{ TimeLeft() | number: "1.2-2" }}</div>
  }
</div>